<template>
    <div class="div tooltip" :data-tooltip="carData.query.vessel">
        <button class="button is-small text-button" :class="{'bold' : isFilled}" @click="openModal" style="min-width: 55px;">
            {{ carData.query.vessel }}
        </button>
        <div class="modal" :class="{'is-active': isActive }">
            <div class="modal-background" @click="isActive = !isActive"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Vessel: {{ carData.query.vessel }}</p>
                    <button class="delete" aria-label="close" @click="isActive = !isActive"></button>
                </header>
                <section class="modal-card-body">
                    <table class="is-fullwidth table is-bordered is-striped">
                        <thead>
                        <tr>
                            <th width="10">Select</th>
                            <th>Name</th>
                            <th width="10">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(vessel, index) in vessels">
                            <td width="10">
                                <button class="button is-info" @click="selectVessel(vessel.name)">
                                        <span class="icon">
                                          <i class="fas fa-check"></i>
                                        </span>
                                </button>
                            </td>
                            <td class="subtitle">{{ vessel.name }}</td>
                            <td width="10">
                                <button class="button is-danger" @click="deleteVessel(index, vessel)">
                                        <span class="icon">
                                          <i class="fas fa-trash"></i>
                                        </span>
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <input v-model="newVessel.name" class="input" type="text" placeholder="Type name of the vessel">
                            </td>
                            <td width="10">
                                <button class="button is-primary" @click="createNewVessel">
                                    <span class="icon">
                                          <i class="fas fa-save"></i>
                                        </span>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </section>
                <footer class="modal-card-foot">
                    <button class="button"  @click="isActive = !isActive">Close</button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import apiVessels from './../../../api/apiVessels'
    import apiCars from './../../../api/apiCars'
    import moment from 'moment'
    export default {
        props:['car'],
        components: {

        },
        data () {
            return {
                isActive: false,
                vessels: [],
                carData:{
                    id: this.car.id,
                    query: {
                        vessel: this.car.vessel === null ? '---' : this.car.vessel,
                    }
                },
                newVessel: {
                    name: ''
                }
            }
        },
        methods: {
            createNewVessel(){
                apiVessels
                    .createVesselRequest(this.newVessel)
                    .then((response) => {
                        this.vessels.push(response.data)
                        this.newVessel.name = ''
                    })
                    .catch(error => console.log(error))
            },
            selectVessel(name) {
                this.carData.query.vessel = name
                apiCars
                    .updateCarRequest(this.carData)
                    .then((response) => {
                        this.isActive = false
                    })
                    .catch(error => console.log(error))
            },
            deleteVessel(index, vessel){
                apiVessels
                    .deleteVesselRequest(vessel.id)
                    .then((response) => {
                        this.vessels = this.vessels.filter(item => item !== vessel)
                        this.newVessel.name = ''
                    })
                    .catch(error => console.log(error))
            },
            openModal() {
                this.isActive = !this.isActive
                apiVessels
                    .vesselListRequest()
                    .then((response) => {
                        this.vessels = response.data
                    })
                    .catch(error => console.log(error))
            }
        },
        computed: {
            isFilled() {
                if (this.carData.query.vessel !== '---'){
                    return  true;
                }
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>
    .text-button {
        max-width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>


// WEBPACK FOOTER //
// src/components/Cars/Columns/VesselColumn.vue